import axios from 'axios';
import { remitterDetailSuccess, remitterError, remitterInsertSuccess, remitterListSuccess, remitterLoading, remitterTypeIdSuccess } from '../../Reducer/Remitter';
import apiUrl from '../../ApiUrl';
import HoldOn from 'react-hold-on';
import {kycActionForRemitter } from '../Kyc';
import toast from 'react-hot-toast';

// Function for inserting remitter data
export const insertRemitterData = (data, studentId, remitterRelation, documentData) => async (dispatch) => {
    dispatch(remitterLoading());
    HoldOn.open({
        theme: 'sk-cube-grid',
        message: 'Inserting remitter data...', 
    });
    
    try {
        const headers = {
            'user_id': studentId,
            "Content-Type": "application/json"
        };
        console.log("dataaa", data);
        const response = await axios.post(`${apiUrl}remitters`, data, {
            headers: headers,
            redirect: 'follow'
        });

        await dispatch(remitterInsertSuccess(response.data));
        await toast.promise(Promise.resolve(response.data), {
            loading: "Inserting remitter data...",
            success: <b>Remitter data inserted successfully!</b>,
            error: <b>Could not insert remitter data.</b>,
        });

        const remitterId = response.data?.remitterId;
        await dispatch(remitterTypeIdSuccess(remitterId));

        // Create KYC data with the received remitterId
        const kycData = {
            "user_id": studentId,
            "remitter_id": remitterId,
            "owner_type": "individual",
            "doc_relation": remitterRelation,
            "ppf_doc_url": documentData?.passportDataFrontStudent,
            "ppb_doc_url": documentData?.passportDataBackStudent,
            "adf_doc_url": documentData?.aadhaarDataFrontRemitters,
            "adb_doc_url": documentData?.aadhaarDataBackRemitters,
            "pan_doc": documentData?.panData
        };
        console.log("kycData For remitter", kycData);

        //for kyc status
        dispatch(kycActionForRemitter(kycData));
        HoldOn.close();
        return response.data;
    } catch (error) {
        dispatch(remitterError(error.message));
        HoldOn.close();
        throw error;
    }
};

// Function for getting remitter list by student ID
export const getRemitterListByStudentId = (studentId) => async (dispatch) => {
    dispatch(remitterLoading());
    HoldOn.open({
        theme: 'sk-cube-grid',
        message: 'Loading remitter data...'
    });
    try {
        const headers = {
            'student-id': studentId
        };
        
        const response = await axios.get(`${apiUrl}remitters/list/id`, {
            headers: headers,
            redirect: 'follow'
        });
        
        await dispatch(remitterListSuccess(response.data));
        HoldOn.close();
        return response.data;
    } catch (error) {
        dispatch(remitterError(error.message));
        HoldOn.close();
        throw error;
    }
};

// You can add more action creators here for other remitter-related actions
export const getRemitterDetailByRemitterId = (remitterId) => async (dispatch) => {
    dispatch(remitterLoading());
    HoldOn.open({
        theme: 'sk-cube-grid',
        message: 'Loading remitter data...'
    });
    try {
        const headers = {
            'remitter-id': remitterId
        };
        
        const response = await axios.get(`${apiUrl}remitters/id`, {
            headers: headers,
            redirect: 'follow'
        });
        
        await dispatch(remitterDetailSuccess(response.data));
        HoldOn.close();
        return response.data;
    } catch (error) {
        dispatch(remitterError(error.message));
        HoldOn.close();
        throw error;
    }
};

// export const getRemitterDetailByRelationship = (studentId, relationship) => async (dispatch) => {
//     dispatch(remitterLoading());
//     HoldOn.open({
//         theme: 'sk-cube-grid',
//         message: 'Loading remitter data...'
//     });
//     try {
//         const headers = {
//             'student-id': studentId,
//             'relation': relationship
//         };
        
//         const response = await axios.get(`${apiUrl}remitters/fetch/detailsByRelationship`, {
//             headers: headers,
//             redirect: 'follow'
//         });

//         const remitterData = response.data?.relationRemitter;
        
//         // Dispatch remitter list data
//         await dispatch(remitterListSuccess(remitterData));
//         console.log("Remitter Data from remitter detail from relationship",remitterData);

//         // For self relationship, also set the remitter ID
//         if (relationship.toLowerCase() === 'self' && remitterData?.remitter_id) {
//             console.log("remitter ID for self-", remitterData?.remitter_id)
//             await dispatch(remitterTypeIdSuccess(remitterData.remitter_id));
//         }

//         HoldOn.close();
//         return response.data;
//     } catch (error) {
//         console.error('Error fetching remitter details:', error);
//         dispatch(remitterError(error.message));
//         HoldOn.close();
//         throw error;
//     }
// };


export const getRemitterDetailByRelationship = (studentId, relationship) => async (dispatch) => {
    dispatch(remitterLoading());

    // Show loading spinner
    HoldOn.open({
        theme: 'sk-cube-grid',
        message: 'Loading remitter data...'
    });

    try {
        const headers = {
            'student-id': studentId,
            'relation': relationship
        };

        // Fetch data from the API
        const response = await axios.get(`${apiUrl}remitters/fetch/detailsByRelationship`, {
            headers: headers,
            redirect: 'follow'
        });

        const remitterData = response.data?.relationRemitter || [];

        // Dispatch remitter data success
        dispatch(remitterListSuccess(remitterData));
        console.log("Remitter Data from remitter detail by relationship:", remitterData);

        // For "self" relationship, set the remitter ID if available
        if (relationship.toLowerCase() === 'self' && remitterData.length > 0) {
            const remitterId = remitterData[0]?.remitter_id; // Assuming remitter_id is part of the remitter details
            if (remitterId) {
                console.log("Setting remitter ID for 'self':", remitterId);
                dispatch(remitterTypeIdSuccess(remitterId));
            }
        }

        // Close loading spinner
        HoldOn.close();

        // Return data for further use in components
        return remitterData;
    } catch (error) {
        console.error('Error fetching remitter details:', error);

        // Dispatch error state
        dispatch(remitterError(error.response?.data?.message || error.message));

        // Close loading spinner
        HoldOn.close();

        // Re-throw the error to allow further handling
        throw error;
    }
};
